import { observer } from 'mobx-react';
import { FC, ReactElement, useEffect } from 'react';
import { Prompt } from 'react-router';
import CookiesEnabledSwitcher from './components/CookiesEnabledSwitcher/CookiesEnabledSwitcher';
import CookiesMessageInput from './components/CookiesMessageInput/CookiesMessageInput';
import CookiesTitleInput from './components/CookiesTitleInput/CookiesTitleInput';
import cookiesStore from './store/cookiesStore';
import { getPromptProps } from 'src/view/components/CustomPrompt/helper';
import LoadingOverlay from '~/view/components/LoadingOverlay/LoadingOverlay';
import ScrollableBlock from '~/view/containers/ScrollableBlock/ScrollableBlock';
import SettingControlsBlock from '~/view/screens/SettingsScreen/containers/SettingControlsBlock/SettingControlsBlock';
import './style.scss';

const CookiesScreen: FC = observer((): ReactElement => {
  useEffect(() => {
    cookiesStore.init();
  }, []);

  return (
    <ScrollableBlock showScrollbar scrollClassName="settings_website_cookies">
      <CookiesEnabledSwitcher />
      <CookiesTitleInput />
      <CookiesMessageInput />

      <SettingControlsBlock setValidation={cookiesStore.setValidation} onSubmit={cookiesStore.updateCookies} />

      <LoadingOverlay visible={cookiesStore.isLoading} />
      <Prompt when={cookiesStore.isEdit} message={getPromptProps()} />
    </ScrollableBlock>
  );
});

export default CookiesScreen;
